module.exports = __webpack_public_path__ + "static/gradients_lightblue-7d3975521e16cc6ac83bcd027398deb9.jpg";